<header class="header" id="site-header">
    <div>
        <a href="/" class="logo p-4 d-block">
          <img src="assets/images/logo-q-2.png" class="w-200 visible-desktop" />
          <img src="assets/images/logo-q.png" class="w-l-100 m-r-10 visible-mobile" />
        </a>
        </div>
    <div > 
      <h1 *ngIf="scroll">Health Consciousness Assesesment</h1>
      <h1 *ngIf="scrollPoniterSteps">{{ categoryData[activeCat]?.name }}</h1>
      <h1 *ngIf="scrollPoniter">
        {{ categoryData[activeCat]?.name }} CATEGORY RESULT
      </h1>
      <h1 *ngIf="priavcy">Privacy Policy</h1>
      <h1 *ngIf="finalAssesment">Health Assesesment Result</h1>
    </div>
  


</header>
